import { Controller } from 'react-hook-form';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import Select, { Option } from 'design-system/components/Select';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Label } from 'design-system/components/Text';
import { ApiModel } from 'lib/interfaces/api';
import { useFormSecurely } from 'lib/security/reactHookForm';

interface EnvironmentCreateModalProps {
  canCreateProduction: boolean;
  canCreateSandbox: boolean;
  submitting: boolean;
  handleCreate: (type: string, name: string) => void;
  handleClose: () => void;
}

const EnvironmentCreateModal = ({
  canCreateProduction,
  canCreateSandbox,
  submitting,
  handleCreate,
  handleClose,
}: EnvironmentCreateModalProps) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { isValid },
  } = useFormSecurely({ mode: 'onChange' });

  return (
    <ModalContainer data-test='environment-create-modal'>
      <ModalHeader onClose={handleClose}>Create new environment</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit((data: any) => handleCreate(data.type, data.name))}>
          <Label htmlFor='type' size='lg' weight='bold'>
            Environment type
          </Label>
          <Controller
            name='type'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select {...field} portal={false}>
                {canCreateProduction && (
                  <Option value={ApiModel.EnvironmentProduction}>Production</Option>
                )}
                {canCreateSandbox && <Option value={ApiModel.EnvironmentSandbox}>Sandbox</Option>}
              </Select>
            )}
          />

          <Spacer height={1} />

          <Label htmlFor='name' size='lg' weight='bold'>
            Environment name
          </Label>
          <Input aria-label='Environment name' {...register('name', { required: true })} />

          <Spacer height={4} />

          <HStack equal={true}>
            <Button variant='basic' id='environment-create-modal__close' onClick={handleClose}>
              Close
            </Button>
            <Button type='submit' disabled={!isValid || submitting}>
              Create environment
            </Button>
          </HStack>
        </form>
      </ModalBody>
    </ModalContainer>
  );
};

export default EnvironmentCreateModal;
